// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only. Unauthorized use,
// copying, or distribution is prohibited and may be prosecuted.
//
// Row identity for custom views (ticket #1022, ASP Rx 135565).
//
// At fill grain a custom view shows one row PER FILL, and sibling fills share __rx_id (the
// prescription). Keying a row by __rx_id made an edit, the drawer, bulk selection and
// double-click address EVERY fill of the prescription at once: setting Welcome Call on refill 1
// painted refill 2, and the drawer opened whichever sibling came first. A row is identified by
// its FILL (__rx_fill_id); __rx_id stays the key for what really is prescription-level — custom
// field values. Base rows and rx-grain views carry no fill id and fall back to the prescription.

export type ViewRow = Record<string, any>

/** The row's own identity: its fill at fill grain, otherwise its prescription. */
export function rowKey(row: ViewRow): string | null {
  if (row['__rx_fill_id'] != null) return String(row['__rx_fill_id'])
  return row['__rx_id'] != null ? String(row['__rx_id']) : null
}

/** The prescription the row belongs to — the key for prescription-level writes. */
export function rxIdOf(row: ViewRow): string | null {
  return row['__rx_id'] != null ? String(row['__rx_id']) : null
}

/**
 * Patch one cell after a save. A WorkBench value belongs to ONE fill ('row'); a custom field
 * value belongs to the prescription and so to every fill row of it ('rx').
 */
export function patchRows(rows: ViewRow[], key: string, scope: 'row' | 'rx', label: string, value: string | null): ViewRow[] {
  const of = scope === 'row' ? rowKey : rxIdOf
  return rows.map(r => of(r) === key ? { ...r, [label]: value } : r)
}

/**
 * The drawer's row for a ?rxd= value. A link saved before rows were keyed by fill carries the
 * prescription id; it still opens that prescription's first row rather than "not found".
 */
export function findRow(rows: ViewRow[], key: string): ViewRow | null {
  return rows.find(r => rowKey(r) === key) ?? rows.find(r => rxIdOf(r) === key) ?? null
}
